/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import UploadIconSvg from "../../../../icons/UploadIconSvg";
import { createFile, getWatermarkedImgixUrl, updateUser } from "services";
import { FileUploaderBase } from "@reusejs/react";
import ProfileIcon2Svg from "../../../../icons/ProfileIcon2Svg";

interface ProfileImageUploaderProps {
  userProfile?: any;
  userUuid?: any;
  onSave?: () => void;
}

export const ProfileImageUploader: React.FC<ProfileImageUploaderProps> = ({
  userProfile,
  userUuid,
  onSave = () => {},
}) => {
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<any>("");

  const handleUploadImage = async (file: any) => {
    if (!file) return;
    try {
      if (file) {
        setLoading(true);
        const data: any = await createFile(file.file, {
          owner_identifier: userUuid,
          owner_service: "user-profile",
        });
        if (!data.key_path) {
          throw new Error("Failed to Upload file");
        }
        let payload = {
          ...userProfile,
          profile_picture: data.key_path,
        };
        const profileData: any = await updateUser(payload);
        if (profileData) {
          setLoading(false);
          setIsModalOpen(true);
          setTimeout(() => setIsModalOpen(false), 1000);
          onSave?.();
        }
      }
    } catch (error) {
      console.log(
        "ProfileImageUploader -> handleUploadImage-> check error:",
        error,
      );
    }
  };
  const handleImageChange = async (file: any) => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result as string);
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.log("check error:", error);
    }
  };
  return (
    <div className=" border border-dashed h-full  pt-[29px] pb-[47px] lg:pt-10 lg:pb-[34px]  flex items-center flex-col lg:justify-between justify-center">
      <div className="">
        <FileUploaderBase
          accept="*/*"
          multiple={false}
          autoUpload={false}
          upload={(file: any) => {
            return new Promise((resolve, reject) => {
              resolve({ name: file.name });
            });
          }}
          selectedFiles={(selectedFiles: any) => {
            setImageFile(selectedFiles[0]);
            handleImageChange(selectedFiles[0]?.file);
          }}
          beforeUpload={(uploadedFiles: any) => {}}
          afterUpload={(uploadedFiles: any) => {
            alert("picture uploaded!");
          }}
          openFileUploader={(triggerClickHandler: () => void) => (
            <Button
              variant={"custom"}
              size={"custom"}
              type="submit"
              onClick={() => triggerClickHandler()}
            >
              {preview ? (
                <img
                  src={preview}
                  className="h-[83px] rounded-full w-[83px] lg:w-[125px] lg:h-[125px] object-cover"
                  alt="Preview"
                />
              ) : userProfile?.profile_picture ? (
                <img
                  className="h-[83px] rounded-full w-[83px] lg:w-[125px] lg:h-[125px] object-cover"
                  src={getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${userProfile?.profile_picture}`,
                  )}
                  alt=""
                />
              ) : (
                <ProfileIcon2Svg className="h-[83px] w-[83px] lg:w-[125px] lg:h-[125px]" />
              )}
            </Button>
          )}
        />
      </div>

      <div className="hidden lg:flex flex-col items-center lg:space-y-4">
        <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
          Browse from your computer
        </p>
        <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
          or
        </p>
        <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
          Drag & drop
        </p>
      </div>

      <div className="flex items-center mt-[18px] lg:hidden">
        <p className="font-openSans font-normal text-web-body-sm leading-[14px ] text-brand-borderGrey">
          Add Image
        </p>
        <UploadIconSvg className="ml-1" />
      </div>

      <Button
        disabled={loading}
        onClick={() => {
          handleUploadImage(imageFile);
        }}
        className="w-[145px] mt-[46px] lg:mt-0  h-9 hover:text-white font-openSans font-semibold text-web-body-md leading-4 text-brand-borderGrey bg-white border border-[#AEAEAE]"
        size={"custom"}
      >
        {" "}
        Save
      </Button>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-20">
          <div className="bg-white p-12 pt-4 pb-4 rounded-lg shadow-lg flex flex-col items-center space-y-4">
            <p className="font-openSans font-semibold text-mobile-body-md lg:text-web-body-lg leading-4  lg:leading-[30px]">
              {" "}
              Profile Updated
            </p>

            <Button
              className="mt-4 px-4 py-0.5 bg-brand-bgBlack text-[12px] text-white rounded"
              onClick={() => setIsModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileImageUploader;
